import React, { Component } from 'react';
import cn from 'classnames';
import InputMask from 'react-input-mask';
import styles from './FormNumber.scss';
import Button from '../../common/Button/Button';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';

class FormNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: '',
      isButtonDisabled: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleInputChange(event) {
    const { value } = event.target;
    this.setState({ number: value, isButtonDisabled: value.length <= 4 });
  }

  handleButtonClick(e) {
    const { numberFormSending } = this.props;
    const { number } = this.state;
    try {
      tracker.sendEvent('Web_Phone_Number_Entered');
      numberFormSending(number.replace(/\s+|\+/g, ''));
    } catch (e) {
      console.log(e);
    }
    e.preventDefault();
  }

  printError(error) {
    const { t } = this.props;

    if (!error) {
      return '';
    }

    if (error === 'USER_NOT_FOUND') {
      return t('components.login.formNumber.userNotFound');
    }

    return t('components.login.formNumber.serverError');
  }

  render() {
    const { isLoading, numberError, t } = this.props;
    const { number, isButtonDisabled } = this.state;

    return (
      <div className={styles.FormInner}>
        <div className={styles.Title}>
          <span>
            {t('components.login.formNumber.title')}
          </span>
        </div>
        <form role="form">
          <div className={cn(styles.Input, numberError && styles.InputError)}>
            <label htmlFor="FormNumber-phone">{this.printError(numberError)}</label>
            <InputMask
              type="tel"
              id="FormNumber-phone"
              value={number}
              placeholder="+7 (999) 999 99 99"
              onChange={this.handleInputChange}
              mask="+7 999 999 99 99"
              maskChar=""
            />
          </div>
          {isLoading ? (
            <div className={styles.Wrapper}>
              <div className={styles.Loader} />
            </div>
            ) : (
              <div style={{ width: '100%' }}>
                <Button
                  type="submit"
                  className={styles.SubmitButton}
                  disabled={isLoading || isButtonDisabled}
                  onClick={this.handleButtonClick}
                >
                  {t('components.login.formNumber.button')}
                </Button>
                <Button className={styles.BlueButton} onClick={() => this.props.onOpenRegistration()}>
                  {t('components.login.formNumber.registration')}
                </Button>
              </div>
            )}
        </form>
      </div>
    );
  }
}

export default withTranslation()(FormNumber);



// WEBPACK FOOTER //
// ./src/components/Login/FormNumber/FormNumber.js